module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-500italic.2f72dc812b7b0c2c1c72ede97fc1d7c7.woff2";